let activeGuard: (() => boolean) | undefined

export function registerUnsavedChangesGuard(guard: () => boolean) {
  activeGuard = guard
  return () => {
    if (activeGuard === guard) activeGuard = undefined
  }
}

export function confirmUnsavedChangesNavigation() {
  return activeGuard ? activeGuard() : true
}
